import { ERequestMethods } from "../enums/RequestMethod";
import { VOUCHER } from "../enums/Voucher";
import { transformFilterQueriesToObject } from "../functions/query";
import { request } from "../libs/request";
import {
  IRequestArgs,
  IResponseData,
  ListResponseData,
} from "../types/requests";
import { IbyUser, IVoucher } from "../types/Voucher";

function getVoucherByCode(code: string) {
  return request<IResponseData<IVoucher>>({
    method: ERequestMethods.GET,
    url: VOUCHER.GET_BY_CODE(code),
  });
}

function applyPromotion(code: string) {
  return request<IResponseData<IVoucher>>({
    method: ERequestMethods.GET,
    url: VOUCHER.APPLY_VOUCHER(code),
  });
}

function revertVoucher(code: string) {
  return request<IResponseData<IVoucher>>({
    method: ERequestMethods.PUT,
    url: VOUCHER.VOUCHER_REVERT(code),
  });
}

function deleteVoucher(id: string) {
  return request<IResponseData<IVoucher>>({
    method: ERequestMethods.DELETE,
    url: `${VOUCHER.GET_ALL}/${id}`,
  });
}

function getAllVouchers(
  { queryParams }: IRequestArgs,
  extraParams: Record<string, unknown>,
) {
  const filterQueries = queryParams?.query?.filter;

  const transformQueries = transformFilterQueriesToObject(filterQueries || []);
  const query = {
    sort: queryParams?.query?.sort,
    ...queryParams?.query?.search,
    ...queryParams?.pagination,
    filter: {
      ...transformQueries,
      ...extraParams,
    },
  };
  return request<ListResponseData<IbyUser>>({
    method: ERequestMethods.GET,
    url: VOUCHER.GET_ALL,
    params: query,
  });
}

const VoucherRepository = Object.freeze({
  getVoucherByCode,
  applyPromotion,
  revertVoucher,
  deleteVoucher,
  getAllVouchers,
});

export default VoucherRepository;
